import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
       
        fetchData(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/publications/v1/getall',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        addPublications(ctx,queryParams){
          //var data = JSON.stringify(queryParams);
          
          return new Promise((resolve, reject) => {
            axios
              .post('/publications/v1/add',queryParams.formData)
              .then(response => resolve(response))
              .catch(error => reject(error))
          })

      },
      updatePublications(ctx,queryParams){
       
         // var data = JSON.stringify(queryParams.formData);
          
          return new Promise((resolve, reject) => {
            axios
              .put('/publications/v1/update/'+queryParams.data.id,queryParams.formData,{
                headers:{
                  'Content-Type': 'multipart/form-data',
                  'dataType':'json'
                }
              })
              .then(response => resolve(response))
              .catch(error => reject(error))
          })

      },
      deletePublications(ctx,id){
        
          
        return new Promise((resolve, reject) => {
          axios
            .delete('/publications/v1/delete/'+id)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })

    },
    fetchImages(ctx, queryParams) {
        var data = JSON.stringify(queryParams);
        
        return new Promise((resolve, reject) => {
          axios
            .post('/publications/v1/image/getall',data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    updateOrdering(ctx, queryParams) {
        var data = JSON.stringify(queryParams);
        
        return new Promise((resolve, reject) => {
          axios
            .put('/publications/v1/image/updateOrdering',data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    
    uploadimages(ctx,queryParams){
      return new Promise((resolve, reject) => {
        axios
          .post('/publications/v1/image/add/'+queryParams.id,queryParams.formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })

    },
    fetchImageDelete(ctx,id){
      return new Promise((resolve, reject) => {
        axios
          .delete('/publications/v1/image/delete/'+id)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })

    }
  }
}